import Axios from 'axios'
import Vue from 'vue'

import BaseEvalObject from "./helpers/baseEvalObject"
// import FormatRefObject from "./helpers/formatRefObject"
import { stateMerge } from "vue-object-merge"

const EvalStore = {
    namespaced: true,
    state: {
        currentEval: {},
        associatedRefType: null,
        associatedCat: {},
        associatedRef: {},
        formValidity: [],
        formCurrentStep: 0,
        formStepsName: [],
        evalsList: [],
        currentPage: 1,
        totalPages: 0,
        itemPerPage: 0,
        sortColumn: 'created_at',
        sortType: 'desc',
        searchQuery: null,
        selectedEvals: []
    },
    getters: {
        searchEvals: (state) => (query) =>{
            if(query != ""){
                return state.evalsList.filter( (evaluation) => {
                    return evaluation.candidate_username.toLowerCase().includes( query.toLowerCase() )
                });
            }else{
                return []
            }
        }
    },
    mutations: {
        initNew(state){
            state.currentEval = BaseEvalObject()
            state.associatedCat = {}
            state.associatedRef = {}
            state.associatedRefType = 'saven'
            state.formValidity = [false, false, true, true]
            state.formStepsName = ["FormStep1", "FormStep2", "FormStep3", "FormStep4", "FormStep5"]
            state.formCurrentStep = 0
        },
        updateFormValidity(state, validityData){
            Vue.set(state.formValidity, validityData.index, validityData.validity)
        },
        changeCurrentStep(state, formData){
            state.formCurrentStep = formData.index
        },
        updateEvalData(state, evalData){
            stateMerge(state.currentEval, evalData)
        },
        setAssociatedObjects(state, associatedData){
            state.associatedRef = associatedData.associatedRef
            state.associatedCat = associatedData.associatedCat
            state.associatedRefType = associatedData.associatedRefType
        },
        indexEvals(state, resp){
            if (resp.meta){
                state.totalPages = resp.meta.total_pages
                state.currentPage = resp.meta.current_page
                state.itemPerPage = resp.meta.item_per_page
                state.searchQuery = resp.meta.search_query
                state.sortColumn = resp.meta.sort_column
                state.sortType = resp.meta.sort_type
            }
            state.evalsList = resp.evaluations
        },
        initEdit(state, evaluation){
            state.currentEval = evaluation
            state.associatedCat = {}
            state.associatedRef = {}
            state.associatedRefType = 'saven'
            state.formValidity = [false, false, true, true]
            state.formStepsName = ["FormStep1", "FormStep2", "FormStep3"]
            state.formCurrentStep = 0
        },
        updateSelectedEvals(state, data){
            if (data.action == 'add'){
                state.selectedEvals.push(data.evaluation_id)
            }else{
                const index = state.selectedEvals.indexOf(data.evaluation_id)
                state.selectedEvals.splice(index, 1)
            }
        },
        resetSelectedEvals(state){
            state.selectedEvals = []
        }
    },
    actions: {
        initNew: initNew,
        createEval: createEval,
        indexEvals: indexEvals,
        initEdit: initEdit,
        saveEval: saveEval,
        resendEmail: resendEmail,
        deleteEval: deleteEval,
        changeSightGroup: changeSightGroup,
        addEvalToSelection: addEvalToSelection,
        removeEvalFromSelection: removeEvalFromSelection,
        resetSelectedEvals: resetSelectedEvals,
        assignSelectedEvals: assignSelectedEvals,
        regenReports: regenReports
    }
}

function changeSightGroup(context, evalData){
    return Axios.put(this.sightApiBaseUrl + "evaluations/" + evalData.id + "/change_sight_group", evalData).then(resp => {
        console.log(resp.data)
        context.commit('updateEvalData', resp.data)
        context.dispatch('indexEvals', {})

    }).catch(err => {
        console.log("EvalStore/Index error", err)
    })
}

function deleteEval(context, evaluation){
    return Axios.delete(this.sightApiBaseUrl + "evaluations/" + evaluation.id )
    .then(resp => {
        return resp
    })
    .catch(err => {
        console.log("EvalStore/Index error", err)
    })
}

function initEdit(context, evalId){
    Axios.get(this.sightApiBaseUrl + "evaluations/" + evalId + '/edit' )
    .then(resp => {
        console.log(resp)
        context.commit('initEdit', resp.data)
    })
    .catch(err => {
        console.log("EvalStore/Index error", err)
    })
}

function indexEvals(context, params){
    const data = {
        sort_column: params.sort_column ? params.sort_column : context.state.sortColumn,
        sort_type: params.sort_type ? params.sort_type : context.state.sortType,
        page: params.page ? params.page : context.state.currentPage,
        search_query: (params.search_query != null) ? params.search_query : context.state.searchQuery
    }
    Axios.get(this.sightApiBaseUrl + "evaluations", {
        params: data
    } ).then(resp => {
        context.commit('indexEvals', resp.data)
    })
    .catch(err => {
        console.log("EvalStore/Index error", err)
    })
}

function initNew(context){
    context.commit('initNew')
}

function createEval(context, evalData){
    Axios.post(this.sightApiBaseUrl + "evaluations", evalData).then(resp => {
        context.commit('updateEvalData', resp.data)
    }).catch(err => {
        console.log("EvalStore/Index error", err.response)
    })
}

function saveEval(context, evalData){
    return Axios.put(this.sightApiBaseUrl + "evaluations/" + evalData.id, evalData).then(resp => {
        console.log(resp.data)
        context.commit('updateEvalData', resp.data)
        context.dispatch('indexEvals')

    }).catch(err => {
        console.log("EvalStore/Index error", err.response)
    })
}

function resendEmail(context, evalData){
    return Axios.post(this.sightApiBaseUrl + "evaluations/" + evalData.id + "/resend_email", evalData).then(resp => {
        return resp.data
    }).catch(err => {
        console.log("EvalStore/resend email error", err.response)
    })
}

function addEvalToSelection(context, evaluation_id){
    context.commit('updateSelectedEvals', {evaluation_id: evaluation_id, action: 'add'})
}
function removeEvalFromSelection(context, evaluation_id){
    context.commit('updateSelectedEvals', {evaluation_id: evaluation_id, action: 'remove'})
}
function resetSelectedEvals(context){
    context.commit('resetSelectedEvals')
}
function assignSelectedEvals(context, params){
    const data = {
        evaluations_ids: context.state.selectedEvals
    }
    Axios.post(this.sightApiBaseUrl + "sight_groups/" + params.sight_group_id + "/assign_evaluations", data).then(resp => {
        return resp.data
        // context.commit('updateEvalData', resp.data)
    }).catch(err => {
        console.log("EvalStore/assignSelectedEvals error", err.response)
    })
}
function regenReports(context, evalData){
    return Axios.put(this.sightApiBaseUrl + "evaluations/" + evalData.id + "/regen_reports", evalData).then(resp => {
        console.log(resp.data)
        context.commit('updateEvalData', resp.data)
        context.dispatch('indexEvals', {})
    }).catch(err => {
        console.log("EvalStore/regenReports error", err)
    })
}


export default EvalStore